import { memo } from 'react';
export const memoGeneric = memo;
